import { createContext, useContext, useEffect, useRef, useState } from 'react';

type Props = {
    timeout: number;
    children: React.ReactNode;
};

const leavingContext = createContext(false);

const jsxNoRender: Set<React.ReactNode> = new Set([false, undefined, '', null]);
const wouldRender = (children: React.ReactNode) => !jsxNoRender.has(children);

export default function DelayUnmount({ timeout, children }: Props) {
    const shouldShow = wouldRender(children);
    const childrenRef = useRef(children);
    const [shouldRender, setShouldRender] = useState(shouldShow);
    const isLeaving = shouldRender && !shouldShow;

    if (shouldShow) {
        // FIXME
        // eslint-disable-next-line react-hooks/refs
        childrenRef.current = children;
    }

    useEffect(() => {
        let timer: number;

        if (shouldShow) {
            // FIXME
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setShouldRender(true);
        } else if (shouldRender) {
            timer = window.setTimeout(() => {
                setShouldRender(false);
                childrenRef.current = null;
            }, timeout);
        }

        return () => window.clearTimeout(timer);
    }, [shouldShow, timeout, shouldRender]);

    return (
        // FIXME
        // eslint-disable-next-line react-hooks/refs
        <leavingContext.Provider value={isLeaving}>{shouldRender ? childrenRef.current : null}</leavingContext.Provider>
    );
}

export const useIsLeaving = () => useContext(leavingContext);
